/* eslint-env browser, jquery */
/* globals Backbone */

'use strict';

const GoodsWarrantyModalView = Backbone.View.extend({
  el: '#goods-warranty-modal',
  scrollOffset: 0,
  events: {
    'click .add-protection': 'addWarranty',
    'click .details-link': 'toggleMoreDetails',
    'click .no-thanks': 'removeWarranty',
    'click .t-back-link': 'hideGoodsWarrantyModal',
  },

  initialize({ model }) {
    this.model = model;
    this.$goodsWarrantyOption = $('.goods-warranty-option');
    this.$touchBackLink = this.$el.find('.t-back-link');
  },

  addWarranty() {
    this.model.set('isSelected', true);
    const goodsWarrantyModal = $('#goods-warranty-modal')[0];
    if (goodsWarrantyModal.dataset.fromBuy) {
      goodsWarrantyModal.dataset.toPurchase = true;
    }

    if (this.$touchBackLink && this.$touchBackLink.length) {
      this.$touchBackLink.click();
    }
  },

  hideGoodsWarrantyModal() {
    const goodsWarrantyModal = $('#goods-warranty-modal')[0];

    if (goodsWarrantyModal.dataset.toPurchase) {
      $('a#buy').click();
      return;
    }

    if (!this.$body) {
      this.$body = $('body');
    }

    if (!this.$mainTouchPane) {
      this.$mainTouchPane = $('#global-container');
    }

    this.$mainTouchPane.show();
    this.$el.hide();
    this.$body.animate(
      {
        scrollTop: this.scrollOffset,
      },
      'slow'
    );
  },

  removeWarranty() {
    this.model.set('isSelected', false);
    const goodsWarrantyModal = $('#goods-warranty-modal')[0];

    if (goodsWarrantyModal.dataset.fromBuy) {
      goodsWarrantyModal.dataset.toPurchase = true;
    }

    if (this.$touchBackLink && this.$touchBackLink.length) {
      this.$touchBackLink.click();
    }
  },

  toggleMoreDetails() {
    if (!this.$detailsLink) {
      this.$detailsLink = this.$el.find('.details-link');
    }

    if (!this.$finePrint) {
      this.$finePrint = this.$el.find('.fine-print-messages');
    }

    this.$finePrint.toggle();
    this.$detailsLink.toggle();
  },
});
module.exports = GoodsWarrantyModalView;
